module.exports = __webpack_public_path__ + "images/kaitori_bonus_lp/step-2-img-pc_04fafde7c71abc6c08239b33ccf9f9e2.png";